import { c as _c } from "react/compiler-runtime";
import { AuthorTooltip } from '@cc-shopping/ui/composites/AuthorTooltip';
import { Box, Typography } from '@mui/material';
import { Fragment } from 'react';
import { StructuredContentRenderer } from 'src/features/content/StructuredContentRenderer';
import { useReviewContext } from '../../../../Context';
import Delimiter from '../Delimiter';
import TooltipTrigger from '../TooltipTrigger';
export default function AuthorNamesAndDate(t0) {
  const $ = _c(12);
  const {
    formattedDate
  } = t0;
  const {
    authors
  } = useReviewContext();
  if (!authors || authors.length === 0) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Typography variant="textSmall" color="text.secondary" paddingRight={1}>By{" "}</Typography>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== authors) {
    let t3;
    if ($[3] !== authors.length) {
      t3 = (author, index) => <Fragment key={author.id}><AuthorTooltip name={author.name} avatarMiniatureURL={author.image.url} socialMediaLinks={author.socialMediaLinks} link={author.link} userPage={author.userPage} bio={author.bio} trigger={<TooltipTrigger />} Renderer={StructuredContentRenderer} /><Delimiter size={authors.length} index={index} /></Fragment>;
      $[3] = authors.length;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    t2 = authors.map(t3);
    $[1] = authors;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <Box display="flex" flexDirection="row" alignItems="center" flexWrap="wrap">{t1}{t2}</Box>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== formattedDate) {
    t4 = formattedDate && <Typography variant="textSmall" color="text.secondary">{formattedDate}</Typography>;
    $[7] = formattedDate;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}